import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataWidgets: localStorage.getItem("dataWidgets")
    ? JSON.parse(localStorage.getItem("dataWidgets"))
    : [],
  newWidget: null,
  activeWidget: localStorage.getItem("activeWidget")
    ? JSON.parse(localStorage.getItem("activeWidget"))
    : null,
  updateWidget: false,
  updateWidgetData: {},
};

const widgetSlice = createSlice({
  name: "widget",
  initialState,
  reducers: {
    setDataWidgets(state, action) {
      state.dataWidgets = action.payload;
    },
    setNewWidget(state, action) {
      state.newWidget = action.payload;
    },
    setActiveWidget(state, action) {
      state.activeWidget = action.payload;
    },
    setUpdateWidget(state, action) {
      state.updateWidget = action.payload;
    },
    setUpdateWidgetData(state, action) {
      state.updateWidgetData = action.payload;
    },
  },
});

export const {
  setDataWidgets,
  setNewWidget,
  setActiveWidget,
  setUpdateWidget,
  setUpdateWidgetData,
} = widgetSlice.actions;

export default widgetSlice.reducer;
